<template><article><h1>范围模式</h1>
<p>以下参数只在范围模式下有效</p>
<ul>
<li><code v-pre>enableCross</code></li>
<li><code v-pre>minRange</code></li>
<li><code v-pre>maxRange</code></li>
<li><code v-pre>fixed</code></li>
</ul>
<h3 id="禁止滑块交叉穿越"><a class="header-anchor" href="#禁止滑块交叉穿越" aria-hidden="true">#</a> 禁止滑块交叉穿越</h3>
<p><example :value="example1"></example></p>
<h3 id="限制滑块之间的距离"><a class="header-anchor" href="#限制滑块之间的距离" aria-hidden="true">#</a> 限制滑块之间的距离</h3>
<p><example :value="example2"></example></p>
</article></template>

<script>
  import examples from '@/examples/range.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>